document.addEventListener('DOMContentLoaded', () => {
  const pickers = document.querySelectorAll('[data-quantity-picker]');

  pickers.forEach((picker) => {
    if (picker.closest('[data-line]')) return;

    const minus = picker.querySelector('[data-quantity-minus]');
    const plus = picker.querySelector('[data-quantity-plus]');
    const value = picker.querySelector('[data-quantity-value]');
    const input = picker.querySelector('[data-quantity-input]');
    minus.addEventListener('click', () => {
      const step = parseInt(input.dataset.quantityStep, 10) || 1;
      const currentPacks = Math.round((parseInt(input.value, 10) || step) / step);

      if (currentPacks > 1) {
        const nextPacks = currentPacks - 1;

        input.value = nextPacks * step;
        value.textContent = nextPacks;
      }
    });

    plus.addEventListener('click', () => {
      const step = parseInt(input.dataset.quantityStep, 10) || 1;
      const currentPacks = Math.round((parseInt(input.value, 10) || 0) / step);
      const nextPacks = currentPacks + 1;

      input.value = nextPacks * step;
      value.textContent = nextPacks;
    });
  });
});